import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-wa-checkbox',
	templateUrl:'./WaCheckboxPage.html',
	styles: [],
	styleUrls:['./WaCheckboxPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class WaCheckboxPage
{
	mdContent_308 = `\`\`\`java
import com.jwebmp.webawesome.components.checkbox.WaCheckbox;
\`\`\``;
	mdContent_309 = `\`\`\`java
new WaCheckbox<>()
\`\`\``;
	mdContent_310 = `\`\`\`java
var cb = new WaCheckbox<>();
cb.setLabel("I agree to the terms");
cb.setRequired(true);
\`\`\``;
}
